<div class="modal fade" tabindex="-1" role="dialog" id="usuario-fabrica-filtro">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 translate class="modal-title">{{'acessos.usuarioFabrica.filtros.definirFiltros'}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container striped-rows">
          <!-- <div class="row ptb5">
            <div translate class="col col-4">
              {{'acessos.usuarioFabrica.filtros.id'}}
            </div>
            <div class="col col-8">
              <input class="form-control form-control-sm" type="number"
                placeholder="{{'acessos.usuarioFabrica.filtros.idPlaceHolder' | translate}}" [(ngModel)]="filtros.id">
            </div>
          </div> -->
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'acessos.usuarioFabrica.filtros.nome'}}
            </div>
            <div class="col col-8">
              <input class="form-control form-control-sm" type="text"
                placeholder="{{'acessos.usuarioFabrica.filtros.nomePlaceHolder' | translate}}" [(ngModel)]="filtros.nome">
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'acessos.usuarioFabrica.filtros.login'}}
            </div>
            <div class="col col-8">
              <input class="form-control form-control-sm" type="text"
                placeholder="{{'acessos.usuarioFabrica.filtros.loginPlaceHolder' | translate}}" [(ngModel)]="filtros.login">
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'acessos.usuarioFabrica.filtros.email'}}
            </div>
            <div class="col col-8">
              <input class="form-control form-control-sm" type="mail"
                placeholder="{{'acessos.usuarioFabrica.filtros.emailPlaceHolder' | translate}}" [(ngModel)]="filtros.email">
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'acessos.usuarioFabrica.filtros.status'}}
            </div>
            <div class="col col-8">
              <select class="form-control form-control-sm" type="text" placeholder="Informe o Status..."
                [(ngModel)]="filtros.status">
                <option translate value="">{{'acessos.usuarioFabrica.filtros.statusPlaceHolder'}}</option>
                <option translate value="1">{{'acessos.usuarioFabrica.filtros.ativos'}}</option>
                <option translate value="0">{{'acessos.usuarioFabrica.filtros.inativos'}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary"
            (click)="filtros.id = '' || filtros.nome = '' || filtros.login = '' || filtros.email = '' || filtros.status = ''">
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-info" data-dismiss="modal">OK</button>
        </div>
      </div>
    </div>
  </div>